<ndt-tile-view
   [canRefresh]="true"
   [callState]="tile?.callState"
   [isEditing]="isEditing"
   [isFullscreen]="isFullscreen"
   [tileConfig]="tileConfig"
   [showHeader]="showHeader"
   [overrideRefreshTile]="false"
   (configureParameters)="onConfigureParameters()"
   ndtTileContainer
   (refreshTile)="onRefreshTile()"
>
   <p tileheadername>{{ tileConfig.dashboardTileLayoutConfiguration.name }}</p>
   <div tileInfo [ngSwitch]="viewMode">
      <div class="medium">
         <ndt-paged-table-wrapper [dataSource]="callParkingData" [rowHeight]="rowHeight">
            <ng-template #pagedTable let-dataSource="dataSource">
               <table id="call-parking-table" lcs-table [dataSource]="dataSource">
                  <tr lcs-header-row *lcsHeaderRowDef="columns"></tr>
                  <tr lcs-row *lcsRowDef="let row; columns: columns"></tr>
                  <ng-container lcsColumnDef="callerIdInformation" [width]="1">
                     <th lcs-header-cell *lcsHeaderCellDef id="callerIdInformation-column-header">Caller Id</th>
                     <td lcs-cell *lcsCellDef="let callParkingLots">
                        {{ callParkingLots.callerIdInformation }}
                     </td>
                  </ng-container>
                  <ng-container lcsColumnDef="parkingSlotNumber" [width]="1">
                     <th lcs-header-cell *lcsHeaderCellDef id="parkingSlotNumber-column-header">Parked In</th>
                     <td lcs-cell *lcsCellDef="let callParkingLots">
                        {{ callParkingLots.parkingSlotNumber }}
                     </td>
                  </ng-container>
                  <ng-container lcsColumnDef="parkerExtension" [width]="1">
                     <th lcs-header-cell *lcsHeaderCellDef id="parkerExtension-column-header">Parked By</th>
                     <td lcs-cell *lcsCellDef="let callParkingLots">
                        <a [routerLink]="getRouterLink(callParkingLots.parkerExtension.extensionId)">
                           {{ callParkingLots.parkerExtension.number }} - {{ callParkingLots.parkerExtension.name }}
                        </a>
                     </td>
                  </ng-container>
                  <ng-container lcsColumnDef="parkDateTime" [width]="1">
                     <th lcs-header-cell *lcsHeaderCellDef id="parkDateTime-column-header" class="numeric"
                        >Time Parked</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let callParkingLots">
                        {{ callParkingLots.parkDateTime | date : 'h:mma' }}
                     </td>
                  </ng-container>
               </table>
            </ng-template>
         </ndt-paged-table-wrapper>
      </div>
   </div>
   <ndt-tile-parameters
      [tileConfig]="tileConfig"
      [formService]="formService"
      *ndtTileParametersDef
      tileParametersList
   ></ndt-tile-parameters>
</ndt-tile-view>
